export default __webpack_public_path__ + "static/cl-cs-mobile-2343cca3e33cd20fea7ba12690048edb.png";